/* global MODE */

var _ = require('lodash');
var Utils = require('./DescartesUtils');
var DescartesEvent = require('./Events/DescartesEvent');
var EventManager = require('./Events/EventManager');



var namespace = {
    DescartesEvent: DescartesEvent,
    EventManager: EventManager
};
_.extend(Utils, namespace);

module.exports = Utils;



//////////////////
// WEBPACK FOOTER
// ./src/DMap/Utils/UtilsNamespace.js
// module id = 474
// module chunks = 0